import { CrewDepartment } from './crew-department.model';

export interface CrewRole {
  id?: number;
  name?: string;
  nameWithDepartment?: string;
  trMsg?: string;
  visible?: boolean;
  crewDepartment?: CrewDepartment;
  year?: number;
}

export enum CrewRoleEnum {
  'Director' = 'crew.role.directing.director',
  'Screenwriter' = 'crew.role.writing.writer',
  'Producer' = 'crew.role.production.producer',
  'Cinematographer' = 'crew.role.camera.director-of-photography',
  'Production Designer' = 'crew.role.production.production-designer',
  'Editor' = 'crew.role.editing.editor',
  'Executive Producer' = 'crew.role.production.executive-producer',
  'Cast' = 'crew.role.acting.actor',
  'Animation by' = 'crew.role.animation.animation-by',
  'Associate Producer' = 'crew.role.production.associate-producer',
  'Reshoot Stunt Coordinators' = 'crew.role.stunts.reshoot-stunt-coordinators',
  'Stunt Coordinator Assistant' = 'crew.role.stunts.stunt-coordinator-assistant',
  'Casting By' = 'crew.role.casting.casting-by',
  'Assistant Editor' = 'crew.role.editing.assistant-editor',
  'Stunt Coordinator' = 'crew.role.stunts.stunt-coordinator',
  'Stunt Double' = 'crew.role.stunts.stunt-double',
  '1st Assistant Director' = 'crew.role.directing.first-assistant-director',
  '2nd Assistant Director' = 'crew.role.directing.second-assistant-director',
  'Associate Director' = 'crew.role.directing.associate-director',
  'Stage Manager' = 'crew.role.directing.stage-manager',
  '1st Assistant Director, Reshoot' = 'crew.role.directing.first-assistant-director-reshoot',
  '2nd Assistant Director, Reshoot' = 'crew.role.directing.second-assistant-director-reshoot',
  '2nd 2nd Assistant Director' = 'crew.role.directing.second-second-assistant-director',
  'Co-Writer' = 'crew.role.writing.co-writer',
  'Co-Production Designer' = 'crew.role.art.co-production-designer',
  '3rd Assistant Director' = 'crew.role.directing.third-assistant-director',
  'Co-Producer' = 'crew.role.production.co-producer',
  'Music' = 'crew.role.music.music',
  'Development Mentor' = 'crew.role.production.development-mentor',
  'Story Editor' = 'crew.role.writing.story-editor',
  'Casting' = 'crew.role.casting.casting',
  'Production Mentor' = 'crew.role.production.production-mentor',
  'Art Director' = 'crew.role.art.art-director',
  'Co-Executive Producer' = 'crew.role.production.co-executive-producer',
  'Casting Director' = 'crew.role.casting.casting-director',
  'Line Producer' = 'crew.role.production.line-producer',
  'Set Decorator' = 'crew.role.art.set-decorator',
  'Costume Design' = 'crew.role.costume.costume-design',
  'Key Makeup' = 'crew.role.makeup.key-makeup',
  'Production Management' = 'crew.role.production.production-management',
  'Supervising Sound Editor' = 'crew.role.sound.supervising-sound-editor',
  'Sound' = 'crew.role.sound.sound',
  'Special Effects' = 'crew.role.special-effects.special-effects',
  'Stunts' = 'crew.role.stunts.stunts',
  'Other Crew' = 'crew.role.other.other-crew',
  'Composer' = 'crew.role.music.composer',
  'Set Teacher' = 'crew.role.production.set-teacher',
  'Story By' = 'crew.role.writing.story-by',
  'Camera Operator' = 'crew.role.camera.camera-operator',
  'Script Supervisor' = 'crew.role.directing.script-supervisor',
  'Visual Effects Editor' = 'crew.role.visual-effects.visual-effects-editor',
  'Adaptation by' = 'crew.role.writing.adaptation-by',
  'Narration' = 'crew.role.narration.narration',
  'Unit Production Mgr' = 'crew.role.production.unit-production-mgr',
  'ADR Mixer' = 'crew.role.sound.adr-mixer',
  'Accountant' = 'crew.role.production.accountant',
  'Animal Trainer' = 'crew.role.production.animal-trainer',
  'Art Department Coordinator' = 'crew.role.art.art-department-coordinator',
  'Assistant Gaffer' = 'crew.role.lighting.assistant-gaffer',
  'Assistant Production Coordinator' = 'crew.role.production.assistant-production-coordinator',
  'Boom Operator' = 'crew.role.sound.boom-operator',
  'Casting Assistant' = 'crew.role.casting.casting-assistant',
  'Catering' = 'crew.role.production.catering',
  'Colorist' = 'crew.role.editing.colorist',
  'Construction Coordinator' = 'crew.role.art.construction-coordinator',
  'Construction Foreman' = 'crew.role.art.construction-foreman',
  'Costumer' = 'crew.role.costume.costumer',
  'Courtesy of' = 'crew.role.production.courtesy-of',
  'Craft Service' = 'crew.role.production.craft-service',
  'DIT' = 'crew.role.camera.dit',
  'Dolly Grip' = 'crew.role.lighting.dolly-grip',
  'Driver' = 'crew.role.production.driver',
  'Extra' = 'crew.role.production.extra',
  'Extras Casting' = 'crew.role.casting.extras-casting',
  'First Aid' = 'crew.role.production.first-aid',
  'First Assistant Camera' = 'crew.role.camera.first-assistant-camera',
  'Foley Artists' = 'crew.role.sound.foley-artists',
  'Foley Mixer' = 'crew.role.sound.foley-mixer',
  'Gaffer' = 'crew.role.lighting.gaffer',
  'Grip' = 'crew.role.lighting.grip',
  'Hair Stylist' = 'crew.role.makeup.hair-stylist',
  'Key Grip' = 'crew.role.lighting.key-grip',
  'Key Set PA' = 'crew.role.production.key-set-pa',
  'Location Manager' = 'crew.role.production.location-manager',
  'Performed by' = 'crew.role.production.performed-by',
  'Production Assistants' = 'crew.role.production.production-assistants',
  'Production Coordinator' = 'crew.role.production.production-coordinator',
  'Production Sound Mixer' = 'crew.role.sound.production-sound-mixer',
  'Property Master' = 'crew.role.art.property-master',
  'Recordist' = 'crew.role.sound.recordist',
  '2nd Assistant Camera' = 'crew.role.camera.second-assistant-camera',
  'Security' = 'crew.role.production.security',
  'Set Dresser' = 'crew.role.art.set-dresser',
  'Sound Editor' = 'crew.role.sound.sound-editor',
  'Sound Effects Editor' = 'crew.role.sound.sound-effects-editor',
  'Special Effects Coordinator' = 'crew.role.special-effects.special-effects-coordinator',
  'Special Effects Foreman' = 'crew.role.special-effects.special-effects-foreman',
  'Still Photographer' = 'crew.role.production.still-photographer',
  'Studio Teacher' = 'crew.role.production.studio-teacher',
  'Stunt Players' = 'crew.role.stunts.stunt-players',
  'Swing' = 'crew.role.production.swing',
  'Transportation Coordinator' = 'crew.role.production.transportation-coordinator',
  'Video Assist' = 'crew.role.camera.video-assist'
}
